export default {
    locale_name: 'Russian',
    locale_shorthand: [ 'ru', 'russian' ],
    // Translations:
    justifyCenter: 'По центру',
    justifyLeft: 'По левому краю',
    justifyRight: 'По правому краю',
    bold: 'Полужирный',
    underline: 'Подчеркнутый',
    italic: 'Курсив',
    code: 'Код',
    headings: 'Заголовок',
    link: 'Ссылка',
    image: 'Вставить изображение',
    orderedList: 'Нумерованный список',
    unorderedList: 'Маркированный список',
    removeFormat: 'Удалить форматирование',
    separator: null,
    table: 'Вставить таблицу',
};
